import algoliasearch from 'algoliasearch/lite';

import appConfig from '../../config/app-config';

const client = algoliasearch(appConfig.algoliaApiId, appConfig.algoliaApiKey);

export const carsIndex = client.initIndex('cars');

export const aerasIndex = client.initIndex('aeras');
